import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useRecentlyViewed } from '../hooks/useRecentlyViewed';
import { proxiedImage, onImgError } from '../utils/images';

// Horizontal rail of recently viewed products; renders nothing when empty.
const RecentlyViewed: React.FC = () => {
  const { items } = useRecentlyViewed();
  if (items.length === 0) return null;

  return (
    <section className="container-custom py-10">
      <div className="flex items-baseline justify-between mb-5">
        <h2 className="text-xl md:text-2xl font-display font-semibold text-earth-900">Recently viewed</h2>
      </div>
      <div className="flex flex-nowrap gap-4 overflow-x-auto overscroll-x-contain touch-pan-x pb-2 -mx-4 px-4 snap-x snap-mandatory" style={{ scrollbarWidth: 'none' }}>
        {items.map((item, i) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3, delay: Math.min(i * 0.04, 0.2) }}
            className="snap-start flex-shrink-0 w-36 md:w-44"
          >
            <Link to={item.handle ? `/products/${item.handle}` : `/products/${item.id}`} className="block group">
              <div className="aspect-square w-full overflow-hidden rounded-xl bg-cream-200 mb-2">
                <img
                  src={proxiedImage(item.image)}
                  alt={item.name}
                  loading="lazy"
                  onError={onImgError()}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <p className="text-sm text-earth-800 leading-snug line-clamp-2 group-hover:text-sage-700 transition-colors">
                {item.name}
              </p>
              {item.price > 0 && (
                <p className="text-sm font-semibold text-sage-700 mt-1">${item.price.toFixed(2)}</p>
              )}
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewed;
